import React from 'react';
import ChangePassword from '../components/RecoverPassword/ChangePassword';

const ChangePasswordPage = () => {

  return (
      <div>
        <ChangePassword />
      </div>
    
  );
};

export default ChangePasswordPage;


/** WEBPACK FOOTER **
 ** ./src/containers/ChangePasswordPage.js
 **/